// Vue Router 4 bootstrap (KAT-943 Phase 2b): `createRouter`/`createWebHistory` replace
// `new Router({ mode: 'history', base, routes })`.
import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'
import { APP_BASE } from '@/config/appBase'

import Spread from '@/views/page/Spread'

import Login from '@/views/auth/Login'
import Logout from '@/views/auth/Logout'

import Start from '@/views/service/Start'
import Book from '@/views/book/Book'
import BookStart from '@/views/book/BookStart'
import Layout from '@/components/Layout'
import LoggedOut from '@/views/service/LoggedOut'
import NoAccess from '@/views/service/NoAccess'
import NotFound from '@/views/service/NotFound'
import Loading from '@/views/service/Loading'

const router = createRouter({
  // APP_BASE is a plain build-time constant now (see src/config/appBase.js) — it was always
  // hardcoded to '' via webpack's DefinePlugin, never actually driven by an env var.
  history: createWebHistory(APP_BASE),
  routes: [
    { path: '/', name: 'Start', component: Start, meta: { service: true } },
    {
      path: '/book/:id',
      component: Book,
      children: [
        {
          path: '',
          component: BookStart,
          name: 'BookStart'
        },
        {
          path: 'page/:pageNumber',
          component: Layout,
          children: [
            { path: '', name: 'Page', component: Spread }
          ]
        }
      ]
    },
    { path: '/login', name: 'Login', component: Login },
    { path: '/logout', name: 'Logout', component: Logout, meta: { service: true } },
    { path: '/loggedout', name: 'LoggedOut', component: LoggedOut, meta: { service: true } },
    { path: '/noaccess', name: 'NoAccess', component: NoAccess, meta: { service: true } },
    { path: '/notfound', name: 'NotFound', component: NotFound, meta: { service: true } },
    { path: '/loading', name: 'Loading', component: Loading, meta: { service: true } },
    // Vue Router 4's path-to-regexp v6 no longer supports a bare `*` wildcard — this is the
    // documented replacement catch-all pattern (named capture group `pathMatch`).
    { path: '/:pathMatch(.*)*', component: NotFound, meta: { service: true } }
  ]
})

router.beforeEach((to, from) => {
  if (to.meta.service) {
    return true
  } else if (to.name !== 'Login' && !store.getters.isLoggedIn) {
    return { name: 'Login', query: { redirect: to.path, bookId: to.params.id, jwt: to.query.jwt } }
  } else {
    if (to.params.id && store.getters.currentUser && store.getters.currentUser.book_id !== to.params.id) {
      return { name: 'Login', query: { redirect: to.path, bookId: to.params.id, jwt: to.query.jwt } }
    } else {
      return true
    }
  }
})

export default router
